import Option from "@p-ban/common/src/components/form/SelectBox/Option"
import Select from "@p-ban/common/src/components/form/SelectBox/Select"
import { range } from "@p-ban/common/src/utils/NumberUtils"

import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import {
  resolvePanelizedItemCntName,
  resolvePanelizedItemKindCntName,
} from "../../../../../service/impositionNameResolver/impositionNameResolver"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import HELP_LINKS from "../../../../constant/helpLinks"

const 面付け数 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const condition = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)
  const shouldShow = condition.panelizedItemCnt || condition.panelizedItemKindCnt

  return (
    <OneClickField isShow={shouldShow} legend="面付け数" helpURL={HELP_LINKS.面付け数}>
      <OneClickFieldStack>
        <Select
          name={FIELD_NAMES.面付け数}
          value={values.panelizedItemCnt}
          onChange={handlers.selectAsNumber}
          aria-label="面付け数"
        >
          {[...range(1, 31)].map((value) => (
            <Option key={value} value={value}>
              {resolvePanelizedItemCntName(value)}
            </Option>
          ))}
        </Select>
        <Select
          name={FIELD_NAMES.種類}
          value={values.panelizedItemKindCnt}
          disabled={disabled.panelizedItemKindCnt}
          onChange={handlers.selectAsNumber}
          aria-label="種類"
        >
          {[...range(1, 31)].map((value) => (
            <Option key={value} value={value}>
              {resolvePanelizedItemKindCntName(value)}
            </Option>
          ))}
        </Select>
      </OneClickFieldStack>
      <OneClickFieldMessages error={errors?.panelizedItemCnt} />
      <OneClickFieldMessages error={errors?.panelizedItemKindCnt} />
    </OneClickField>
  )
}

export default 面付け数
